import React from 'react'
import PropTypes from 'prop-types'
import useStyles from './styles'

import IconButton from '@material-ui/core/ButtonBase'

class ChromeCastButton extends React.Component {
  render() {
    const props = this.props
    const buttonProps = Object.assign({}, props)
    delete buttonProps.gclClassName

    return (
      <IconButton {...buttonProps}>
        <google-cast-launcher class={props.gclClassName} />
      </IconButton>
    )
  }
}

export default ChromeCastButton



// WEBPACK FOOTER //
// ./src/components/VideoButtons/ChromeCastButton/index.jsx